import Hotjar from '@hotjar/browser'
import { hotjarVersion, siteId } from '@constants/hotjar'

export function startHotjar() {
  Hotjar.init(siteId, hotjarVersion, {
    debug: __DEV__,
  })
}
